export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) {
        return "0.00";
    }
    return Number(amount).toFixed(2);
};